export default {
	yourTemples: "Your Temples",
	createNew: "Create new temple",
	noTemple: "No temple",
	createDialog: {
		title: "Create New Temple",
		name: "Temple Name",
		nameHint: "Capitalize each word (or type it all in uppercase)",
		acronym: "Acronym",
		acronymHint: "2-10 uppercase characters, letters and numbers only. Will be used as identifier.",
		slugTaken: "This acronym is already in use. Choose another.",
	},
	roles: {
		title: "Role",
		owner: "Owner",
		admin: "Administrator",
		member: "Member",
	},
	settings: "Temple Settings",
	publicAgenda: {
		navLabel: "Public agenda",
		enableLabel: "Enable public agenda",
		enableHint: "Publishes a page with a unique link where people can see rituals and reserve a spot",
		linkLabel: "Public link",
		linkHint: "Share this link. It securely identifies your temple.",
		rotateLink: "Generate new link",
		linkCopied: "Link copied!",
		linkRotated: "New link generated. The previous one no longer works.",
		acceptReservations: "Accept reservations",
		acceptReservationsHint: "Lets people reserve a spot for published rituals",
		requirePhone: "Require phone",
		requireEmail: "Require email",
		requirePhoto: "Require photo",
		requirePhotoHint: "The visitor takes a photo (webcam) to complete the reservation.",
		seeNotifications: "See reservation notifications",
		agendaWindowDays: "Agenda window (days)",
		agendaWindowDaysHint: "How many days ahead to show rituals",
		welcomeText: "Short description",
		welcomeTextHint: "Shown at the top of the public page, below the name (optional)",
		longDescription: "Long description",
		longDescriptionHint: "Shown in the “More information” tab (optional)",
		visibleFields: {
			title: "Show on the public page",
			hint: "Data from the house profile. Only checked items are shown.",
			phone: "Phone",
			whatsapp: "WhatsApp",
			email: "Email",
			address: "Address",
			instagram: "Instagram",
			facebook: "Facebook",
			notRegistered: "not registered",
		},
		qrCode: "QR code",
		rotateConfirm: {
			title: "Generate a new link?",
			warning: "The current link will stop working immediately. Anyone who already has the old link will no longer be able to access the agenda.",
			instruction: "To confirm, type the code below:",
			mismatch: "The code does not match.",
			confirm: "Generate new link",
		},
		qrDialog: {
			title: "Agenda QR code",
			hint: "Download or print it to share. Pointing a camera at it opens the public agenda.",
			download: "Download",
			print: "Print",
		},
	},
	settingsLabels: {
		defaultCountryCode: "Default country code",
		defaultCountryCodeHint: "Pre-filled next to the phone number in forms.",
		templeData: "Temple Data",
		general: "General",
		contact: "Contact",
		address: "Address",
		schedule: "Schedule",
		visualIdentity: "Visual Identity",
		printing: "Printing",
		email: "Email",
		notifications: "Notifications",
		name: "Temple Name",
		tradition: "Tradition",
		cnpj: "CNPJ",
		razaoSocial: "Legal Name",
		description: "Description",
		foundedAt: "Foundation Date",
		phone: "Phone",
		whatsapp: "WhatsApp",
		templeEmail: "Temple Email",
		instagram: "Instagram",
		facebook: "Facebook",
		saved: "Settings saved successfully!",
	},
	schedule: {
		title: "Operating Days & Shifts",
		morning: "Morning",
		afternoon: "Afternoon",
		evening: "Evening",
		days: {
			mon: "Monday",
			tue: "Tuesday",
			wed: "Wednesday",
			thu: "Thursday",
			fri: "Friday",
			sat: "Saturday",
			sun: "Sunday",
		},
	},
	emailSettings: {
		sendReportOnClose: "Send report on ritual close",
		sendReportOnCloseHint: "Automatically sends the report by email to admins when closing a ritual",
		birthdayEmailEnabled: "Send daily birthday email",
		birthdayEmailEnabledHint: "Sends an email each morning with the list of today's birthdays",
		birthdayRecipients: "Recipients",
		birthdayRecipientsHint: "Select who should receive the birthday email",
		recipientAdmins: "Administrators",
		recipientAllUsers: "All users",
		recipientGuides: "Guide members",
		receiptEmailEnabled: "Send receipt by email",
		receiptEmailEnabledHint: "When a payment is registered, automatically sends a receipt by email to the member (if they have an email address)",
	},
	attendanceTimeSettings: {
		title: "Attendance",
		timeSectionTitle: "Ticket attendance time",
		timeSectionDescription: "Controls the visual time indicators on the ticket call screen",
		warningMinutes: "Warning time (yellow)",
		warningMinutesHint: "Ticket turns yellow after this time (minutes)",
		limitMinutes: "Limit time (red)",
		limitMinutesHint: "Ticket turns red after this time (minutes)",
	},
	financialSettings: {
		tabGeneral: "General",
		sectionTitle: "Automatic Billing",
		advanceDays: "Advance days",
		advanceDaysHint: "Generate charges {n} days before due date (between 5 and 25)",
		defaultDueDays: "Default due date (days)",
		defaultDueDaysHint: "An open charge without a due date is created with {n} days from today (between 0 and 20; 0 = due today)",
		sendPaymentReminders: "Send payment reminders",
		sendPaymentRemindersHint: "Sends a reminder email 3 days before the due date",
		sendOverdueAlerts: "Send overdue alerts",
		sendOverdueAlertsHint: "Sends an alert email 1 day after the due date",
		allowEditAmountOnSettle: "Allow editing the amount when settling",
		allowEditAmountOnSettleHint: "When enabled, the operator can adjust the amount when settling a charge or membership fee. When disabled, settlement clears the exact charged amount.",
		residualChargePolicy: "Charge for the residual balance when editing the amount on settlement",
		residualChargePolicyHint: "Defines what happens to the difference when the amount paid is less than the charged amount: forgive it, ask on every settlement, or automatically generate a charge for the remaining balance.",
		residualChargePolicyOptions: {
			FORGIVE: "Disabled — the remaining balance is forgiven",
			ASK: "Ask at the time of settlement",
			ALWAYS: "Always charge the remaining balance",
		},
	},
	whatsappSettings: {
		sectionTitle: "WhatsApp Alerts",
		sectionDescription: "Messages sent from ORI's official number, mentioning the temple's name.",
		enabled: "Enable WhatsApp alerts",
		enabledHint: "Sends financial notices via WhatsApp in addition to email",
		sendPaymentReminders: "Due date reminders",
		sendPaymentRemindersHint: "Sends a WhatsApp reminder before charges are due",
		sendOverdueAlerts: "Overdue alerts",
		sendOverdueAlertsHint: "Sends a WhatsApp alert when a charge becomes overdue",
		sendPaymentConfirmations: "Payment confirmations",
		sendPaymentConfirmationsHint: "Sends a WhatsApp confirmation when a payment is approved",
		sendAdminAlerts: "Administrator alerts",
		sendAdminAlertsHint: "Sends administrators notices of received payments, expenses, duplicates and pending closing (each admin must enable WhatsApp in their own profile)",
		optInNote: "Each person only receives messages if they have a valid phone number and consent (opt-in) recorded in their profile.",
	},
	notifications: {
		channelsTitle: "Delivery channels",
		channelsDescription: "Choose which channel each notice is sent through. Email is the default channel; WhatsApp is an additional channel.",
		emailChannel: "Email",
		emailChannelDesc: "Main channel, always available to those with an email address on file.",
		channelDefault: "Default",
		whatsappChannel: "WhatsApp",
		whatsappChannelDesc: "Messages sent from ORI's official number, mentioning the temple's name.",
		whatsappOptInNote: "Each person only receives messages if they have a valid phone number and consent (opt-in) recorded in their profile.",
		whatsappAddonChip: "Get add-on",
		whatsappAddonNote: "WhatsApp alerts are an add-on and are not included in your current plan. Purchase the add-on to enable this channel.",
		colEvent: "Event",
		colEmail: "Email",
		colWhatsapp: "WhatsApp",
		sectionMember: "Charges (for the member)",
		sectionAdmin: "Administrator alerts",
		sectionReports: "Reports and relationship",
		eventNewCharge: "New charge generated",
		eventNewChargeHint: "Notice sent when a new charge or membership fee is created.",
		eventReminder: "Payment reminder",
		eventReminderDaysPre: "Send",
		eventReminderDaysPost: "days before the due date (0 to 3; 0 = on the day)",
		eventOverdue: "Overdue charge",
		eventOverdueHint: "Notice sent the day after the due date.",
		eventConfirmation: "Payment confirmed / receipt",
		eventConfirmationHint: "Receipt sent when the payment is approved.",
		eventAdmin: "Alerts for the board",
		eventAdminHint: "Payment received, expenses due/overdue, duplicates and pending monthly closing.",
		eventClosingReport: "Monthly closing report",
		eventClosingReportHint: "Sent with the PDF when closing the month.",
		eventBirthday: "Member birthday",
		eventBirthdayHint: "List of the day's birthdays, early in the morning.",
		sectionReservations: "Public schedule",
		eventNewReservation: "New reservation",
		eventNewReservationHint: "Notifies admins when a public reservation is confirmed and enters the review queue.",
		recipientsLabel: "Recipients:",
		footNote: "Essential notices (new charge, failed direct debit) are always sent when the channel is active. WhatsApp requires the person to have opted in.",
		alwaysTooltip: "Always sent when the channel is active",
		whatsappOffTooltip: "Enable the WhatsApp channel above",
		emailOnlyTooltip: "Available by email only",
	},
	printing: {
		autoPrint: "Auto-print when creating ticket",
		autoPrintHint: "When enabled, printing will be triggered whenever a ticket is created during the ritual",
		autoPrintScheduled: "Print tickets for scheduled rituals",
		autoPrintScheduledHint: "When enabled, tickets distributed in future rituals will also be printed automatically",
		paperWidth: "Paper width",
		customMessage: "Custom message",
		customMessageHint: "Text displayed at the bottom of the receipt (max. 200 characters)",
		receiptEnabled: "Enable receipt printing",
		receiptEnabledHint: "Shows the print receipt button on paid financial movements",
		showLogo: "Print temple logo on ticket",
		showLogoHint: "When disabled, the ticket will be printed without the temple logo",
		previewBeforePrint: "Preview the receipt before printing",
		previewBeforePrintHint: "Shows the receipt on screen, with the print button inside, so name, amount and date can be checked before spending paper. When off, it prints directly.",
		previewReceiptTitle: "Receipt",
		previewHint: "Check it before spending paper.",
		previewPrint: "Print",
		previewPrintFailed: "Could not open the print dialog. Please try again.",
		kioskManualHint: "To set up silent printing, check the",
		kioskManualLink: "printing manual",
		testPrint: "Print test page",
	},
	pixSettings: {
		disabledByMp: "With the Mercado Pago integration active, this feature is disabled — charges use Mercado Pago's dynamic PIX.",
		enabled: "Include PIX QR Code in billing emails",
		enabledHint: "When enabled, reminder and overdue emails will include a PIX QR Code with the amount pre-filled",
		sectionDescription: "Set up the PIX key that will be used to generate the QR Code.",
		keyType: "PIX Key Type",
		key: "PIX Key",
		keyHint: "CPF, CNPJ, email, phone or random key",
		keyTypeRequired: "Choose the key type before entering the PIX key",
		keyInvalid: {
			CPF: "Invalid CPF — check the 11 digits",
			CNPJ: "Invalid CNPJ — check the 14 digits",
			EMAIL: "Invalid or too long e-mail (max 77 characters)",
			PHONE: "Invalid phone — enter area code and number, from a Brazilian phone",
			RANDOM: "Invalid random key — 36 characters with hyphens, exactly as your bank provided",
		},
		recipientName: "Recipient Name",
		recipientNameHint: "Name shown on PIX transaction (max 25 characters)",
		city: "City",
		cityHint: "Recipient city (max 15 characters)",
	},
	preSenhaSettings: {
		usePreSenha: "Use pre-queue number for attendance",
		usePreSenhaHint: "Enables the pre-queue number calling system on the ticket distribution page",
	},
	invites: "Invites",
	pendingInvites: "Pending Invites",
	noInvites: "No pending invites",
	inviteCode: "Invite Code",
	inviteCodeDescription: "Share this code to invite members",
	generateCode: "Generate Code",
	revokeCode: "Revoke Code",
	codeExpires: "Expires in",
	copyCode: "Copy code",
	codeCopied: "Code copied!",
	inviteByEmail: "Invite by Email",
	sendInvite: "Send Invite",
	email: "Guest email",
	role: "Role",
	ritualFunction: "Ritual Function",
	ritualFunctionHint: "E.g.: Medium, Cambono, Ogã (optional)",
	inviteSent: "Invite sent successfully!",
	inviteRevoked: "Invite revoked",
	expired: "Expired",
	pending: "Pending",
};
